module.exports = __webpack_public_path__ + "static/zipper-std-5480af3616837d449c04ecd2f5b36f1b.otf";